import { CustomButton } from '@/components/ui/CustomButton';
import React from 'react';

export const Footer = () => (
  <div className="bg-[#F3F4F8] border-t py-12 md:py-14 lg:py-[4.5rem] border-[#CBCDD6]">
    <div className="container flex flex-col items-center">
      <h2 className="text-3xl text-[#0C0D1A] font-semibold text-center mb-6 max-w-[40rem] md:text-4xl">
        Grow your later life knowledge  <span className="text-[#006EB7]"> with our academy</span>
      </h2>

      <p className="text-base text-[#5B5D6B] font-450 text-center mb-6 max-w-[43rem]">
        We offer insightful guides and articles to help you broaden your understanding.
        Explore these free resources today.
      </p>

      <div>
        <a href="/professionals/resources/academy" target="_blank" rel="noreferrer noopener">
          <CustomButton
            variant="primaryLarge"
            className="justify-center"
          >
           View academy
          </CustomButton>
        </a>
      </div>
    </div>
  </div>
);
